import React from 'react';
import styled, { StylesProps } from '../../../lib/styles';
import Spacer from '../../../components/presentational/Spacer';
import Typography from '../../../components/presentational/Typography';
import titleStyles from './Title_styles';
import StoryByline from '../../../components/presentational/StoryByline';
import { trackEvent } from '../../../lib/ga';
import { AUTHOR_CLICKED, SHARE } from '../lib/ga';
import ArticleSharing from '../ArticleSharing';

export interface TitleProps {
  title: string;
  link: string;
  author?: {
    avatar_96?: string;
    name?: string;
    title?: string;
    tagline?: string;
    link?: string;
  };
  sponsored_brand?: {
    avatar_96?: string;
    name?: string;
    title?: string;
    tagline?: string;
    link?: string;
  };
  sponsored: boolean;
  category?: string;
  created?: string;
  children?: any;
}

const determineLabel = (
  author: TitleProps['author'],
  sponsored_brand: TitleProps['sponsored_brand']
) => {
  if (author && sponsored_brand) {
    if (author.name !== sponsored_brand.name) {
      return ` by ${sponsored_brand.name}`;
    }
  }
  return '';
};
const Title = ({
  title,
  link,
  author,
  sponsored_brand,
  created,
  category = 'News',
  children,
  styles,
}: TitleProps & StylesProps<typeof titleStyles>) => {
  return (
    <Spacer space={'s'}>
          
      <Spacer space={'xxxs'}>
              
        {category && (<small className={styles.attribution}>
          <em>{category}</em>
        </small>
        )}
              
        <Typography>
                  <h1>{children || title}</h1>
                
        </Typography>
            
      </Spacer>
      <div>
        <div className={styles.sponsored}>
          <a href={sponsored_brand?.link} className={styles.sponsoredLink}>
            Sponsored{determineLabel(author, sponsored_brand)}
          </a>
        </div>
         
      </div>
      <div className={'d-flex justify-content-between align-items-center'}>
        {author && (
          <StoryByline
            author={author as any}
            created={created}
            onAuthorClick={() =>
              trackEvent(
                { ...AUTHOR_CLICKED, label: author.name },
                { transport: 'beacon' }
              )
            }
          />
        )}
        <ArticleSharing
          link={link}
          brand="sas"
          onShare={network =>
            trackEvent(
              { ...SHARE, label: network },
              { transport: 'beacon' }
            )
          }
        />
      </div>
    </Spacer>
  );
};

export default styled(titleStyles)(Title);
